import { LoadSavedMappings, SavedModelPortfoliosAction } from './saved-model-portfolios.actions';
import * as actions from './saved-model-portfolios.actions';
import { savedModelPortfoliosInitialState } from './saved-model-portfolios.init';
import { SavedModelPortfoliosState } from './saved-model-portfolios.interfaces';

export function savedModelPortfoliosReducer(state = savedModelPortfoliosInitialState, action: SavedModelPortfoliosAction): SavedModelPortfoliosState {
	switch (action.type) {
		case actions.LOAD_SAVED_MAPPINGS: {
			const actionPayload: Map<string, string> = (<LoadSavedMappings>action).savedPortfolioMapping;
			return {
				savedPortfolioMapping: actionPayload
			};
		}
		case actions.ADD_SAVED_STORE_MAPPING: {
			const newMapping = (<actions.AddSavedStoreMapping>action).newMapping;

			const updatedMappings: Map<string, string> = getCombinedCopy(state.savedPortfolioMapping, newMapping);

			return {
				savedPortfolioMapping: updatedMappings
			};
		}
		case actions.REMOVE_SAVED_STORE_MAPPING: {
			const portfolioId = (<actions.RemoveSavedStoreMapping>action).portfolioId;

			const newState: Map<string, string> = getCombinedCopy(state.savedPortfolioMapping);
			newState.delete(portfolioId);

			return {
				savedPortfolioMapping: newState
			};
		}
		case actions.REMOVE_SAVED_STORE_MAPPINGS: {
			const portfolioIds = (<actions.RemoveSavedStoreMappings>action).portfolioIds;

			const newState: Map<string, string> = getCombinedCopy(state.savedPortfolioMapping);
			portfolioIds.forEach(id => newState.delete(id));

			return {
				savedPortfolioMapping: newState
			};
		}
		default: {
			return state;
		}
	}

	function getCombinedCopy<K, V>(...maps: Map<K, V>[]): Map<K, V> {
		const combinedCopy: Map<K, V> = new Map<K, V>();

		maps.forEach(map => {
			map.forEach((value, key) => {
				combinedCopy.set(key, value);
			});
		});

		return combinedCopy;
	}
}
